import imageTitle from 'assets/img/illustrations/ticket-greetings.png';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import TitleSelectorSupportDesk from '../dashboards/general/TitleSelectorSupportDesk';
import TicketSinSolucion from './TicketSinSolucion';
import DonutSoporteCard from './DonutSoporteCard';
import LastSupportTickets from './LastSupportTickets';
import CustomerFeedbackList from './customer-feedback/CustomerFeedbackList';
import CustomerSatisfaction from './customer-satisfaction/CustomerSatisfaction';
import NetPromotionScore from './net-promotion-score/NetPromotionScore';
import NumberOfTickets from './number-of-tickets/NumberOfTickets';
const CatalogoTicketSoporte = () => {

    const [agentesSoporte, setAgentesSoporte] = useState([]);
    const { token, setToken } = useToken();
    const [cargandoAgentesSoporte, setCargandoAgentesSoporte] = useState(true);
    const { showErrorToast } = useToast();
    const ObtenerListaAgentesSoporte = async () => {
        setCargandoAgentesSoporte(true);
        const response = await fetch("/api/home/ObtenerListaVendedores", {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);

            });

        if (response.ok) {
            console.log(response);
            const data = await response.json();
            //Tabla con lista de agentesSoporte
            setAgentesSoporte(data);
        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setCargandoAgentesSoporte(false);

    };

    useEffect(() => {
        ObtenerListaAgentesSoporte();
    }, []);

    return (
        <>
            <Row className="g-3">
                <Col xxl={12}>
                    <Row className="g-0 h-100">
                        <Col xs={12}>
                            <TitleSelectorSupportDesk
                                title1={"Akasia"}
                                title2={"Support Desk"}
                                barChart={imageTitle}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="gx-3 mb-3">
                <Col xxl={12} xl={12}>
                    <TicketSinSolucion
                    />
                </Col>
            </Row>
            <Row className="g-3 mb-3">
                <Col xxl={8}>
                    <NumberOfTickets
                        agentesSoporte={agentesSoporte}
                        cargandoAgentesSoporte={cargandoAgentesSoporte}
                    />
                </Col>
                <Col md={6} xxl={4}>
                    <CustomerSatisfaction
                    />
                </Col>
            </Row>
            <Row className="g-3 mb-3">
                <Col xxl={8} md={6}>
                    <DonutSoporteCard></DonutSoporteCard>
                </Col>
                <Col md={6} xxl={4}>
                    <NetPromotionScore />
                </Col>
            </Row>
            <Row className="gx-3 mb-3">
                <Col xxl={12} xl={12}>
                    <LastSupportTickets
                        agentesSoporte={agentesSoporte}
                        cargandoAgentesSoporte={cargandoAgentesSoporte}
                    ></LastSupportTickets>
                </Col>
            </Row>
            
            <Row className="g-3 mb-3">
                <Col xxl={12}>
                    <CustomerFeedbackList />
                </Col>
            </Row>

        </>
    );
};

export default CatalogoTicketSoporte;
